(function() {
'use strict';
  
  angular.module('app.metrics', [
    
  ]);
  
})();